import React, { useRef, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ja from "date-fns/locale/ja";
import { format } from "date-fns";
import { getEnableDate, formatDate } from "~/functions/FormatDate";

const InputPartyDate = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { changeDate, ...other } = props;

    let [enable_date, set_enable_date] = React.useState(enable_date);
    useEffect(() => {
        //6営業日後を取得
        dispatch(getEnableDate(null)).then((data) => {
            enable_date = new Date();
            if(data?.payload?.enable_date)
            {
                set_party_date(new Date(data.payload.enable_date));
                set_enable_date(new Date(data.payload.enable_date));
                changeDate(new Date(data.payload.enable_date));
            }
            else
            {
                //取得失敗の場合、500エラーページへ
                history.push(`/Error`);
                // if(data?.payload?.result === "NG") return;
                // enable_date.setDate(enable_date.getDate() + 6);
                // changeDate(enable_date);
            }
        });
    }, []);

    const [party_date, set_party_date] = React.useState(enable_date);

    const setValue = (val) => {
        if (isNaN(val?.getTime())) {
            //不正な日付を入力させない
            return;
        }

        if (val < enable_date) {
            // alert("6日以降の日付を入力してください。");
            alert(formatDate(enable_date, 'YYYY/MM/DD') + "以降の日付を入力してください。");
            return;
        }

        let enable_month = new Date();
        enable_month.setMonth(enable_month.getMonth() + 3);
        if (val > enable_month)
        {
            alert("3ヶ月より先は入力できません。");
            return;
        }

        set_party_date(val);
        changeDate(val);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
            <DatePicker
                label="開催日"
                value={party_date}
                onChange={(newValue) => {
                    setValue(newValue);
                }}
                renderInput={(params) => (
                    <TextField
                        name="party_date"
                        value={party_date}
                        required
                        // sx={{ minWidth: "10rem", maxWidth: "15rem", mb: 3 }}
                        {...params}
                        {...other}
                    />
                )}
                inputFormat="yyyy年MM月dd日"
                mask="____年__月__日"
                leftArrowButtonText="前月を表示"
                rightArrowButtonText="次月を表示"
                toolbarTitle="日付選択"
                cancelText="キャンセル"
                okText="選択"
                {...other}
            />
        </LocalizationProvider>
    );
};

export default InputPartyDate;
